<template>
  <div class="w-full  mb-4">
    <button @click="addLineItem"
            class="w-full py-2 border text-yellow   transition block  border-yellow  relative ">
      <div
          class="  text-center top-0 left-0 w-full h-full flex items-center justify-center  text-[18px] leading-[1.03] uppercase">
        Buy now
      </div>
    </button>
  </div>
</template>

<script setup>
import Client from 'shopify-buy';
import { ref, onMounted, watch } from 'vue';
import { inject } from 'vue'

const lineItems = ref(null);
const checkoutUrl = ref(null);
console.log('in cart');


const props = defineProps({
  variant: {
    type: String
  }
});


// const checkoutId = 'gid://shopify/Checkout/2f09adb9dcfedbb0d28f7a8f2903dc11?key=2cca215f6381f4b55bcae9449c72776b'
const loading = ref(false);

let formatCurrency = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'
});

const emitter = inject('emitter'); // Inject `emitter`

onMounted(() => {
  console.log('mounted');
  console.log(props.variant);

});


const addLineItem = () => {

  emitter.emit('addToCart', {
    variant: props.variant
  });

}
</script>